import clsx from "clsx";
import { LandingCtas } from "./LandingCtas";

export const LandingTextImageContent = ({ data }) => {
  return (
    <section
      className={clsx(
        "section-layout",
        data?.fields?.text_position === "center" && "section-layout-column",
      )}
    >
      <div
        className={clsx(
          "LandingTextImageContent-col",
          "LandingTextImageContent-col-text",
          data?.fields?.text_position &&
            `LandingTextImageContent-col-text-position-${data?.fields?.text_position}`,
        )}
      >
        {data?.fields?.headline && <h2>{data?.fields?.headline}</h2>}
        {data?.fields?.subheadline && <p>{data?.fields?.subheadline}</p>}
        {data?.fields?.content && (
          <div
            className="LandingTextImageContent-dangerous-content"
            dangerouslySetInnerHTML={{ __html: data?.fields?.content }}
          />
        )}
        {data?.fields?.ctas && <LandingCtas ctas={data?.fields?.ctas} />}
      </div>
      {data?.fields?.show_image && (
        <div className="LandingTextImageContent-col">
          {data?.fields?.image && (
            <img src={data?.fields?.image.src} alt={data?.fields?.image_alt} />
          )}
        </div>
      )}
    </section>
  );
};
